"use client"

import { GetComponentQuery, GetPageByRouteQuery } from "@eurodrive/apollo"
import { BlockRenderer } from "@eurodrive/ui"
import { getBreadCrumbs, transformProperties } from "@eurodrive/utils"
import { LeasingCarDto, SaleCarDto } from "api"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  finalSelectedCars: SaleCarDto[]
  finalSelectedLeasingCars: LeasingCarDto[]
  leasingImageMap: Record<string, string>
  brands: {
    image: string
    title: string
    logo: string
    url: string
  }[]
  contactForm: GetPageByRouteQuery
  carsUmbraco: GetComponentQuery
}

// Define the components mapping object based on the block types from the query
const components = {
  heroBannerInnerPages: () => import("@eurodrive/ui/Banner"),
  selectContactForm: () => import("@eurodrive/ui/FormBlock"),
  comparisonSelectCars: () => import("./ComparisonSelectCars"),
}

export default function Comparison({
  data,
  contactForm,
  locale,
  brands,
  carsUmbraco,
  finalSelectedCars,
  finalSelectedLeasingCars,
  leasingImageMap,
}: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)

  return (
    <>
      {blocks?.blocks?.map((block: any, index: number) => {
        let blockProps = {}
        if (block.blockType === "heroBannerInnerPages") {
          blockProps = { breadCrumbs, compact: true }
        }
        if (block.blockType === "selectContactForm") {
          blockProps = { contactForm }
        }
        if (block.blockType === "comparisonSelectCars") {
          blockProps = { brands, carsUmbraco, finalSelectedCars, finalSelectedLeasingCars, leasingImageMap }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={blockProps}
          />
        )
      })}
    </>
  )
}
